// i18n area 'system' — locale tr-TR (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.tr-TR.meta.json.
import type { enUS } from './system'

export const trTR: typeof enUS = {
  diagnostics: {
    title: 'Tanılama',
    subtitle: 'Neyin yanlış olduğu, en kötüsü önce — tvirt diagnose ile aynı mercek',
    reload: 'Yeniden yükle',
    loadError: 'Tanı okunamadı',
    exportBundle: 'Paketi dışa aktar',
    exportError: 'Paket oluşturulamadı',
    noProblem: 'İncelenen alanlarda sorun yok',
    nothingInspected: 'HİÇBİR ŞEY incelenmedi — bu bir sağlık belgesi değildir',
    inspected: 'İncelendi',
    notInspected: 'İNCELENMEDİ',
    localHint: "Düğümün yerel alanları (systemd birimleri, journal) yalnızca CLI'dan okunur: tvirt diagnose --area local — API yanıt vermediğinde izlenecek yol.",
    thresholds: '{hours} saat içindeki başarısız görevler, {seconds} sn üzeri geciken heartbeat',
    severity: {
      critical: 'Kritik',
      warning: 'Uyarı',
      unknown: 'Bilinmiyor'
    }
  },
  explorer: {
    title: 'Kaynak gezgini',
    root: 'Kök',
    empty: "Bu scope'ta kaynak yok",
    previewHint: 'Önizleme için bir nesne seçin',
    open: 'Aç',
    openScoped: "Listeyi bu scope'ta aç",
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM şablonu',
      ct: 'CT',
      ctTemplate: 'CT şablonu',
      app: 'App',
      overlayNetwork: 'Overlay ağı',
      networkService: 'Ağ hizmeti',
      fabric: 'Fabric',
      subnet: 'Alt ağ',
      storage: 'Depolama havuzu',
      disk: 'Disk',
      catalogFile: 'Katalog dosyası',
      ociRegistry: 'OCI kayıt defteri',
      ociImage: 'OCI görüntüsü',
      cephCluster: 'Ceph kümesi',
      backupDestination: 'Yedek hedefi',
      user: 'Kullanıcı',
      group: 'Grup',
      role: 'Rol',
      credential: 'Kimlik bilgisi',
      tag: 'Etiket',
      proximityRule: 'Yakınlık kuralı'
    }
  },
  tags: {
    title: 'Etiketler',
    empty: 'Etiket yok',
    add: 'Etiket ekle',
    remove: 'Kaldır',
    name: 'Etiket',
    value: 'Değer',
    save: 'Kaydet',
    saveError: 'Etiketler kaydedilemedi',
    loadError: 'Etiket sözlüğü yüklenemedi',
    noVocabulary: 'Bu kaynak türü için kullanılabilir etiket yok',
    overwrite: 'Mevcut değeri değiştir',

    // Sistema > Tag, superficie del vocabolario.
    createTitle: 'Etiket oluştur',
    editTitle: 'Etiketi düzenle',
    nameHint: 'Harf, rakam, nokta, tire ve alt çizgi — ":" ve "/" kullanılamaz; tvirt- öneki platforma ayrılmıştır',
    cardinality: 'Kardinalite',
    cardinalitySingle: 'Tek değer',
    cardinalityMultiple: 'Birden çok değer',
    cardinalityHint: 'Tek değerde, etiketi yeniden atamak onu değiştirmeyi ister',
    autoCreate: 'Değerleri otomatik oluştur',
    autoCreateOn: 'Atama sırasında',
    autoCreateOff: 'Yalnızca bildirilenler',
    autoCreateHint: 'Açık: yeni bir değer atamak onu oluşturur. Kapalı: yalnızca bildirilen değerler atanabilir',
    values: 'Değerler',
    noValues: 'Bildirilen değer yok',
    addValue: 'Değer ekle',
    duplicateValue: 'Yinelenen değer',
    kinds: 'Kaynak türleri',
    kindsAll: 'Tümü',
    kindsPlaceholder: 'Tümü',
    kindsHint: 'Etiketlenebilir her kaynak türüne izin vermek için boş bırakın',
    systemChip: 'Sistem',
    deleteCascade: 'Atamaları da kaldır',
    deleteCascadeHint: 'Hâlâ bir kaynağa atanmış bir etiket reddedilir: bu seçenekle değerler ve tüm atamalar etiketle birlikte gider.'
  },
  scopes: {
    title: "Scope'lar",
    createTitle: 'Scope oluştur',
    editTitle: "Scope'u yeniden adlandır",
    path: 'Yol',
    segment: 'Segment',
    segmentHint: 'Küçük harf, rakam ve tire (DNS-1123)',
    parent: 'Üst öğe',
    rootChip: 'Kök',
    preview: 'Yeni scope',
    pickLabel: 'Scope',
    pickHint: 'Nesnenin küme ağacında yaşadığı yer — kök ya da altındaki bir vDC.',
    ociCache: 'OCI önbelleği (override)',
    appEphemeral: 'App geçici havuzu (override)',
    inherit: 'Devral',
    inheritsFrom: 'Devralma kaynağı',
    inheritsCluster: 'Küme varsayılanını devralır',
    inheritsNone: 'Devralır — etkin havuz yok',
    failoverProtection: 'Bozulma durumunda koruma',
    networkWeight: 'Ağ ağırlığı',
    networkCeil: 'Ağ tavanı (Mbps)',
    protectionProtected: 'Korumalı',
    protectionExpendable: 'Bozulma durumunda feda edilebilir',
    protectionDefault: 'Küme varsayılanı'
  },

  // Sistema > Informazioni (round #124).
  sysinfo: {
    summary: 'Kümedeki platform sürümleri, her düğümün bileşenleri, yönetim el kitabı ve lisans.',
    platformTitle: 'TVirt platformu',
    platformSubtitle: 'Küme düğümlerinde gözlemlenen sürümler',
    versionOnNodes: '{n} düğümde {version}',
    versionOnOneNode: '1 düğümde {version}',
    mixedVersions: 'Kümede birden fazla platform sürümü — yalnızca devam eden bir yükseltme sırasında beklenir (en fazla iki).',
    tooManyVersions: 'Kümede ikiden fazla platform sürümü — yükseltme sırasında bile hiç beklenmez: aşağıdaki düğümleri denetleyin.',
    unreportedNodes: 'Şuradan henüz sürüm raporu yok: {nodes}',
    noVersionsYet: 'Henüz hiçbir düğüm sürümlerini bildirmedi.',
    nodesUnavailable: 'Düğüm listesi izinlerinizle görünür değil — platform sürümleri gösterilemiyor.',
    colNode: 'Düğüm',
    manualTitle: 'Yönetim el kitabı',
    manualSubtitle: 'Bu küme tarafından sunulan yerel kopya',
    manualBody: 'PDF olarak eksiksiz TVirt el kitabı, doğrudan platform tarafından sunulur — air-gapped ortamlarda da kullanılabilir.',
    manualLink: 'Yönetim el kitabı (PDF)',
    apiExplorerTitle: 'API gezgini',
    apiExplorerSubtitle: 'OpenAPI sözleşmesi, gezilebilir',
    apiExplorerBody: 'Platformun eksiksiz OpenAPI sözleşmesi — her rota, şema ve yanıt kodu — tarayıcıdan gezilebilir, bu düğüm üzerinden sunulur.',
    apiExplorerLink: 'API\'yi keşfet',
    kubeTitle: 'Kubernetes uyumluluğu',
    kubeSubtitle: 'kubectl ve araçları, yerel API\'nin önünde',
    kubeBody: 'TVirt KubeCompat; Pod, Deployment, Service, namespace, düğüm ve olayları Kubernetes lehçesine yansıtır — salt okunur, artı Deployment silme. Her çağrı senin izinlerinle yerel API üzerinden geçer: kubeconfig içinde bearer olarak bir app token kullan.',
    kubeEndpoint: 'kubectl için endpoint',
    kubeStatusActive: 'Etkin — Kubernetes {version}',
    kubeStatusMissing: 'Bu düğümde kurulu değil (trantor-tvirt-kubecompat paketi)',
    kubeStatusDown: 'Kurulu ama yanıt vermiyor — trantor-tvirt-kubecompat birimini kontrol et',
    kubeStatusChecking: 'Kontrol ediliyor…'
  },

  // Licensing (round 2026-07-29).
  licensing: {
    title: 'Küme lisansı',
    subtitle: 'Abonelik lisansı — küme başına en fazla bir',
    absentTitle: 'Kayıtlı lisans yok',
    absentBody:
      "Geçerli bir lisans olmadan küme yeni sanal makineleri başlatmayı reddeder (açık VM'ler açık kalır). Abonelikle birlikte gelen ürün anahtarını kaydedin.",
    registerButton: 'Lisansı kaydet',
    removeButton: 'Lisansı kaldır',
    state: {
      ok: 'Geçerli',
      limitExceeded: 'Limit aşıldı',
      expired: 'Süresi doldu'
    },
    productKeyLabel: 'Ürün anahtarı',
    basisLabel: 'Limit temeli',
    basis: {
      concurrentVms: "Aynı anda açık VM'ler",
      physicalCores: 'Fiziksel çekirdek (küme toplamı)'
    },
    limitLabel: 'Limit',
    usageLabel: 'Geçerli kullanım',
    usageOf: '{limit} üzerinden {used}',
    usagePartial: 'kısmi toplam — gözlemlenen CPU topolojisi olmayan {n} düğüm',
    usageUnknown: 'şu anda gözlemlenemiyor',
    expiresLabel: 'Sona erme',
    neverExpires: 'hiçbir zaman',
    registeredLabel: 'Kayıt tarihi',
    gateNote:
      "Lisans yokken, süresi dolmuşken veya limitin ötesindeyken küme YENİ sanal makineleri başlatmayı reddeder. Açık VM'ler açık kalır ve HA yeniden başlatmaları bundan etkilenmez.",
    devStage:
      'Geliştirme aşaması: ürün anahtarı, burada bildirilen limitlerle birlikte olduğu gibi kabul edilir; imzalı anahtar doğrulaması gelecekteki bir sürümde gelecek.',
    dialogTitle: 'Lisansı kaydet',
    dialogExpiresHelp: 'Boş = lisansın süresi hiç dolmaz',
    dialogSubmit: 'Kaydet',
    dialogError: 'Lisans kaydedilemedi.',
    removeTitle: 'Lisansı kaldır',
    removeBody:
      "Küme LİSANSSIZ kalacak: bir lisans kaydedilene kadar yeni sanal makineler başlamayı reddedecek. Açık VM'ler açık kalır.",
    removeConfirm: 'Kaldır',
    removeError: 'Lisans kaldırılamadı.'
  },
  rbac: {
    tabRoles: 'Roller',
    tabGrants: 'Yetkilendirmeler',
    rolesTitle: 'Roller',
    createRoleTitle: 'Rol oluştur',
    editRoleTitle: 'Rolü düzenle',
    nameHint: 'Küçük harf, rakam ve tire; tvirt- öneki ayrılmıştır',
    systemChip: 'Sistem',
    permissions: 'İzinler',
    permissionsPlaceholder: 'İzin ekle…',
    includedRoles: 'Dahil edilen roller',
    includedRolesPlaceholder: 'Rol ekle…',
    grantsTitle: 'Yetkilendirmeler',
    createGrantTitle: 'Yetkilendirme oluştur',
    principal: 'Principal',
    principalKind: 'Principal türü',
    principalUser: 'Kullanıcı',
    principalGroup: 'Grup',
    role: 'Rol',
    grantRight: 'Yetki devri',
    grantRightChip: 'Devredebilir',
    grantRightLabel: 'Devir hakkıyla (alan kişi bu rolü başkalarına da devredebilir)',
    effective: 'Etkin',
    notEffective: 'Etkin değil',
    createdAt: 'Oluşturuldu',
    scopeHint: '/path tam, /path/* özyinelemeli — yetkilendirmeler bağlanmış bir köke sabitlenir (/* yetkilendirilemez)'
  },
  groups: {
    title: 'Gruplar',
    createTitle: 'Grup oluştur',
    nameHint: 'Küçük harf, rakam ve tire; scope içinde benzersiz',
    members: 'Üyeler',
    membersTitle: 'Üyeler',
    membersPlaceholder: 'Kullanıcı ekle…',
    noMembers: 'Üye yok',
    realmMappings: 'Realm eşlemeleri',
    realmMappingsTitle: 'Realm eşlemeleri',
    realmMappingsHint:
      'Bu grubun her bir dış realm içindeki karşılığı. Üyelik, oturum açma sırasında dizinden okunur: burada kimsenin eşlemediği bir dizin grubu yok sayılır ve iç içe yapı çözümlenmez — dizin tarafında düzleştirilmelidir.',
    realm: 'Realm',
    externalGroup: 'Dış grup',
    addRealmMapping: 'Eşleme ekle',
    removeRealmMapping: 'Eşlemeyi kaldır',
    noRealmMappings: 'Realm eşlemesi yok',

    // Dialog di creazione a sezioni (round realm-wizard).
    sectionGeneral: 'Genel',
    mappingsNoRealms: 'Yapılandırılmış dış realm yok — eşleme yüzeyi, bir realm var olur olmaz açılır.',
    mappingsNoRealmsLink: 'Realm ve SSO sekmesini aç',

    // Obbligo MFA di gruppo (round #178 metà B).
    mfaRequired: 'MFA zorunluluğu',
    mfaRequiredChip: "MFA'yı zorunlu kılar",
    mfaNotRequiredChip: 'Zorunluluk yok',
    mfaRequiredHint:
      'Saf OR: bir grup, üyelerine ikinci faktör zorunluluğunu EKLEYEBİLİR — realm eşlemeleri üzerinden dış kimliklere de — ama asla kaldıramaz. Bir sonraki oturum açmadan itibaren geçerlidir: açık oturumlar kapatılmaz.'
  },
  users: {
    title: 'Kullanıcılar',
    createTitle: 'Kullanıcı oluştur',
    editTitle: 'Kullanıcıyı düzenle',
    username: 'Kullanıcı adı',
    usernameHint: 'Küçük harf, rakam, nokta ve tire',
    displayName: 'Görünen ad',
    enabled: 'Etkin',
    state: 'Durum',
    enabledChip: 'Etkin',
    disabledChip: 'Devre dışı',
    lockedChip: 'Kilitli',
    password: 'Parola',
    passwordSetChip: 'Ayarlandı',
    mustChangeChip: 'Değiştirilmeli',
    initialPassword: 'İlk parola',
    initialPasswordHint: 'Kullanıcı ilk oturum açmada parolayı değiştirmek zorundadır',
    lastLogin: 'Son oturum açma',
    neverLoggedIn: 'Hiç oturum açmadı',
    setPasswordTitle: 'Parola ayarla',
    setPasswordHint: 'Yönetimsel değiştirme — parolanızı gerektirir (sudo modu) ve kullanıcıyı bir sonraki oturum açmada parolayı değiştirmeye zorlar.',
    operatorPassword: 'Parolanız',
    unlock: 'Hesabın kilidini aç',
    revokeTitle: 'Oturumları geçersiz kıl',
    revokeBody: 'Bu kullanıcının tüm etkin oturumları hemen sonlandırılır.',
    revokeIncludeTokens: "App token'larını da geçersiz kıl",
    revokeConfirm: 'Geçersiz kıl',

    // Dialog standard (round #156).
    tabAccount: 'Hesap',
    tabSecurity: 'Güvenlik',
    usernameImmutableHint: 'Kullanıcı adı hesabın kimliğidir — oluşturmada sabitlenir',
    groups: 'Gruplar',
    noGroups: 'Grup yok',
    mustChangePassword: 'Parola değişikliği zorunlu',
    failedAttempts: 'Başarısız oturum açma denemeleri',
    lockedUntil: 'Şu tarihe kadar kilitli',

    // Identity tabs (2026-08-03).
    tabUsers: 'Kullanıcılar',
    tabGroups: 'Gruplar',
    tabRealms: 'Realm ve SSO',
    tabMfa: 'MFA',

    // Tab MFA (task #178, metà A + metà B).
    mfa: {
      title: 'İkinci faktör (MFA)',
      methodsTitle: 'Kullanılabilir yöntemler',
      methodsSubtitle: 'Bu kurulumun ikinci faktör olarak doğrulayabildikleri',
      methodsError: 'Yöntem kayıt defteri yüklenemedi',
      builtinChip: 'Yerleşik',
      enrollableChip: 'TVirt içinde enrollment',
      delegatedChip: 'Dışarıda yönetilir',
      state: 'Durum',
      stateActive: 'Etkin',
      statePending: 'Enrollment bekliyor',
      stateNone: 'Kaydolmamış',
      required: 'MFA zorunluluğu',
      requiredChip: 'Zorunlu',
      notRequiredChip: 'Zorunlu değil',
      enrolledAt: 'Enrollment tarihi',
      enrolledMethods: 'Kayıtlı yöntemler',
      noMethods: 'Enrollment yok',
      codesRemaining: 'Kalan kurtarma kodları',
      resetTitle: 'İkinci faktörü sıfırla',
      resetHint:
        "Enrollment ve tüm kurtarma kodları silinir: bir sonraki oturum açmada kullanıcı enrollment'ı baştan yapar. MFA zorunluluğu olduğu gibi kalır — bir yönetici asla bir gizli değer ayarlamaz, onu yalnızca sıfırlar.",
      resetConfirm: 'Sıfırla',
      resetError: 'İkinci faktör sıfırlanamadı',
      empty: 'Henüz yönetilen kullanıcı yok — hesaplar var olur olmaz burada görünür, her biri kendi ikinci faktör durumuyla.',

      // Metà B (round #178).
      viaSelf: 'Kişisel',
      viaSelfHint: 'Hesabın kendi katkısı (kendi bayrağı) — kalemin düzenlediği tek kısım.',
      viaGroupHint: 'Bu gruptan devralınan zorunluluk: kişisel bayrağı kaldırmak kullanıcıyı serbest bırakmaz — grup üzerinde, Gruplar sekmesinden işlem yapılır.',
      subject: 'Kimlik',
      lastSeenAt: 'Son doğrulama',
      enrollmentPending: 'Beklemede',
      orphanChip: 'Sahipsiz',
      orphanDirectoryMiss: 'Kimlik artık dizinde değil',
      orphanRealmRemoved: "Realm TVirt'ten kaldırıldı",
      orphanedAt: 'Sahipsiz kaldığı tarih',
      directoryUuid: 'Dizindeki UUID',
      externalTitle: "Dış enrollment'lar",
      externalEmpty: 'Henüz dış enrollment yok — MFA zorunluluğu altındaki bir dizin kimliğinin ilk oturum açışında doğar.',
      orphanHelp:
        'Sahipsiz bir enrollment asla kendi kendine silinmez: güvenlik malzemesidir — audit için kalır ve kimlik dizinde yeniden görünürse faktörünü yeniden bulur. Tek çıkış yönetimsel sıfırlamadır.',
      visibilityHint: "Dış enrollment'lar küme kökünde bulunur: onları yalnızca tüm ağaç üzerinde user.read iznine sahip olanlar görür.",
      orphanResetHint:
        "Sahipsiz satır kalıcı olarak kaldırılır: artık kimse onu sahiplenmez. Kimlik dizinde yeniden görünürse enrollment'ı baştan yapar.",
      enforcingTitle: "MFA'yı zorunlu kılan gruplar",
      enforcingSubtitle:
        'Dış kimlikler için zorunluluğun çapası gruptur: realm eşlemeleri hangi dizin nüfusuna ulaştığını söyler. Dış enrollment, zorunlu tutulan kullanıcının ilk oturum açışında doğar.',
      enforcingEmpty: "Hiçbir grup MFA'yı zorunlu kılmıyor — zorunluluk grup üzerinde, Gruplar sekmesinden etkinleştirilir.",
      enforcingError: "MFA'yı zorunlu kılan gruplar yüklenemedi"
    }
  },
  realms: {
    title: 'Kimlik doğrulama realmleri',
    createTitle: 'Realm oluştur',
    editTitle: 'Realmi düzenle',
    name: 'Realm',
    nameHint: 'Kullanıcıların @ işaretinden sonra yazdığı alan adı (example.com) — oluşturma sonrasında değiştirilemez',
    nameImmutableHint: 'Realm adı, onu anan her oturuma ve her audit satırına damgalanır — yeniden adlandırmak geçmişi yeniden yazmak olurdu',
    kind: 'Tür',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC ve SAML sonraki roundlarla geliyor — bugün bir realm, bir LDAPv3 dizinidir',

    // Semi-wizard di creazione (round realm-wizard).
    kindCategory: 'Realm türü',
    kindSelectHint: 'Bu realmin kimlik doğrulaması yapacağı dizin türünü seçin.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Kullanıcı adı ve parola, bir LDAPv3 dizininde bind ile doğrulanır — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: "Tarayıcıdan single sign-on, bir OpenID Connect identity provider'ına devredilir — sonraki roundlarla geliyor."
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'SAML 2.0 onaylamalarıyla kurumsal single sign-on — sonraki roundlarla geliyor.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Etkin',
    urls: 'Dizin sunucuları',
    urlsHint: 'Satır başına bir ldap:// veya ldaps:// URL (1–8), sırayla denenir — yük devretme, asla dengeleme',
    startTls: 'StartTLS',
    verifyCertificate: 'Sertifikayı doğrula',
    cleartextWarning: 'ldaps:// veya StartTLS olmadan bind parolası ağdan düz metin olarak geçer — laboratuvar için kabul edilebilir, üretim için asla.',
    noVerifyWarning: 'Doğrulanmamış bir TLS oturumu kimsenin kimliğini doğrulamaz: doğrulamayı yalnızca düzeltemeyeceğiniz bir dizine karşı kapatın.',
    caCertificate: 'CA sertifikası (PEM)',
    caCertificateHint: "Bu realmin TLS/StartTLS handshake'i için sabitlenen isteğe bağlı CA bundle'ı; boş bırakmak kaldırır",
    caCertificatePinned: 'Sabitlenmiş',
    connectTimeout: 'Zaman aşımı (saniye)',
    connectTimeoutHint: 'URL başına bağlantı ve istek süresi (1–60); dolduğunda sıradaki URL denenir',
    bindDn: 'Bind DN',
    bindDnHint: 'Kullanıcı aramasını çalıştıran service account; boş = anonim search bind (AD tarafından reddedilir)',
    anonymousBind: 'Anonim search bind',
    bindCredential: 'Bind parolası (keystore)',
    bindCredentialHint: 'Bind parolasını tutan bir usernamePassword keystore girdisi — gizli değer asla realm üzerinde yaşamaz',
    bindCredentialNone: 'Yok (anonim bind)',
    bindCredentialEmpty: "Keystore'da usernamePassword girdisi yok — bind parolası için Sistem > Kimlik bilgileri altında bir tane oluşturun.",
    baseDn: 'Base DN',
    baseDnHint: 'Kullanıcı aramasının başladığı alt ağaç (DC=example,DC=com)',
    userFilter: 'Kullanıcı filtresi',
    userFilterHint: '%u, oturum açma adının yerel kısmıyla değiştirilir, RFC 4515 escape uygulanır; AD olmayan dizinler tipik olarak (&(objectClass=inetOrgPerson)(uid=%u)) ister',
    memberOfAttribute: 'memberOf özniteliği',
    memberOfAttributeHint: 'Yalnızca bir kez, oturum açmada okunur — eşlenmemiş gruplar yok sayılır, iç içe yapı çözümlenmez',
    uuidAttribute: 'UUID özniteliği',
    uuidAttributeHint: "Realm içindeki değiştirilemez UUID (AD'de objectGUID, OpenLDAP'te entryUUID) — audit'te kullanıcı@realm yanına damgalanır",
    displayNameAttribute: 'Görünen ad özniteliği',
    displayNameAttributeHint: 'Kullanıcıyı selamlamak için kullanılır; yoksa oturum açma adı kullanılır',
    sudoHint: 'Realm yazmaları sudo korumalıdır: bir realm, platforma açılan bir kapıdır',
    deleteBody: 'Realmin grup eşlemeleri onunla birlikte gider; kimliğini doğruladığı oturumlar süreleri dolana kadar canlı kalır — silinmiş bir realm sadece artık kimseyi içeri almaz.',
    tabConnection: 'Bağlantı',
    tabDirectory: 'Dizin',
    testTitle: 'Bağlantıyı sına',
    testHint: 'Bir yapılandırma sondası, asla bir kimlik doğrulama değil: bağlanır, service account ile bind yapar ve — bir kullanıcı adıyla — kullanıcı filtresini çalıştırır.',
    testUsername: 'Kullanıcı adı (isteğe bağlı)',
    testUsernameHint: 'Kullanıcı filtresinin çalıştırılacağı bir yerel kısım — 1 eşleşme sağlıklı yanıttır',
    testRun: 'Sınamayı çalıştır',
    testError: 'Sonda çalıştırılamadı',
    testReachable: 'Dizin erişilebilir, service bind kabul edildi',
    testUnreachable: 'Dizine ERİŞİLEMİYOR',
    matchedOne: 'Kullanıcı filtresi tam olarak 1 girdi buldu — sağlıklı yanıt.',
    matchedNone: 'Kullanıcı filtresi hiçbir girdi bulamadı: filtre ya da base DN yanlış.',
    matchedMany: 'Kullanıcı filtresi {count} girdi buldu: seçici değil ve oturum açmalar belirsiz olurdu (reddedilir).',
    mappingsPointer: 'Bir dış grubun neye karşılık geldiği TVirt grubunun bir özelliğidir (realm eşlemeleri): doğruluk noktası Gruplar sekmesinde yaşar.',
    mappingsPointerLink: 'Gruplar sekmesini aç',
    rootHomeHint: 'Dış bir realmin kimlikleri küme kökünde yaşar, asla bir vDC içinde değil: izinler gerektiği yerde, yetkilendirmelerle atanır — grup üzerinde ya da doğrudan kullanıcı üzerinde, tıpkı yerel hesaplarda olduğu gibi.'
  },
  credentials: {
    title: 'Kimlik bilgileri',
    createTitle: 'Kimlik bilgisi oluştur',
    editTitle: 'Kimlik bilgisini düzenle',
    kind: 'Tür',
    kindUsernamePassword: 'Kullanıcı adı ve parola',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph kimliği)',
    kindHintUsernamePassword: "Değiştirilemez. CIFS/SMB depolamaları için — worker'ın mount anında gizli değerini kullandığı mount hesabı.",
    kindHintIscsiChap: 'Değiştirilemez. iSCSI CHAP kimlik doğrulaması için — username = CHAP adı, secret = CHAP gizli değeri.',
    kindHintNvmeDhchap: "Değiştirilemez. NVMe over Fabrics DH-HMAC-CHAP için — secret = DHHC-1:xx:… blob'u; username yalnızca bir etiket.",
    kindHintCephx: 'Değiştirilemez. Ceph clientları için — username = client adı (client.…), secret = base64 anahtar.',
    kindImmutableHint: 'Tür oluşturma sonrasında değiştirilemez — değiştirmek yeni bir kimlik bilgisi demektir.',
    username: 'Kullanıcı adı',
    usernameChap: 'CHAP adı',
    usernameNvme: 'Etiket',
    usernameCephx: 'Client adı',
    usernameHint: 'Gizli değerin ait olduğu isteğe bağlı hesap',
    usernameHintChap: "Initiator'ın kimlik doğrulamada kullandığı CHAP adı",
    usernameHintNvme: 'Aktarım tarafından kullanılmaz — kendi notlarınız için serbest bir etiket',
    usernameHintCephx: 'cephx client adı — client. önekine izin verilir',
    secret: 'Gizli değer',
    secretHint: 'Salt yazılır: tüketicilerce kullanılır, bir daha asla gösterilmez.',
    secretHintNvmeDhchap: 'Salt yazılır: kanonik DHHC-1:xx:… biçimindeki host DH-HMAC-CHAP gizli değeri — tüketicilerce kullanılır, bir daha asla gösterilmez.',
    secretHintCephx: 'Salt yazılır: base64 cephx anahtarı — tüketicilerce kullanılır, bir daha asla gösterilmez.',
    secretEditHint: 'Gizli değeri değiştirmemek için boş bırakın — doldurmak onu döndürür.',
    createdAt: 'Oluşturuldu',
    inUseError: "'{name}' bir depolamanın yapılandırmasında referans alınıyor — önce orada çıkarın.",
    nameHint: 'Küçük harf, rakam ve tire (DNS-1123); scope başına benzersiz',

    // Dialog di sola rotazione (round #156).
    rotateTitle: 'Gizli değeri döndür',
    rotateHint: 'Salt yazılır: yeni gizli değer saklananın yerine geçer — tüketiciler onu bir sonraki mount sırasında kullanır.',

    // Round #159 (PKI).
    tabSecrets: 'Gizli değerler',
    tabCertificates: 'Sertifikalar',
    tabAuthorities: 'Sertifika yetkilileri',
    certificatesTitle: 'Sertifikalar',
    authoritiesTitle: 'Sertifika yetkilileri',
    caCreateTitle: 'Yeni CA',
    certCreateTitle: 'Yeni sertifika',
    caMode: 'Kaynak',
    caModeGenerate: 'TVirt ile üret',
    caModeImport: 'İçe aktar (anahtar + sertifika)',
    certMode: 'Kaynak',
    certModeIssue: "Keystore'daki bir CA'dan ver",
    certModeImport: 'İçe aktar (anahtar + sertifika)',
    issuingCa: 'Veren CA',
    issuingCaHint: "Sertifika CA'nın scope'unda doğar, parent kaydedilir",
    noCasHint: "Keystore'da CA yok — önce CA sekmesinde bir tane üretin ya da içe aktarın",
    commonName: 'Common name (CN)',
    commonNameCaHint: "CA'nın subject'i: harf, rakam, boşluk, nokta, alt çizgi, tire",
    commonNameCertHint: "OpenVPN clientları CN'den tanır — CA başına benzersiz tutun",
    days: 'Geçerlilik (gün)',
    daysCaHint: '1–7300 gün; varsayılan 3650 (10 yıl)',
    daysCertHint: '1–3650 gün; varsayılan 365',
    keyType: 'Anahtar türü',
    keyTypeHint: 'Varsayılan EC P-256; legacy tüketiciler için RSA',
    usage: 'Kullanım',
    usageClient: 'Client (clientAuth)',
    usageServer: 'Sunucu (serverAuth)',
    usageHint: 'Sertifikanın verildiği extended key usage',
    san: 'Alternatif adlar (SAN)',
    sanHint: 'Virgülle ayrılır; IP değişmezleri IP: girdisi olur, geri kalanı DNS:',
    keyPem: 'Özel anahtar (PEM)',
    keyPemHint: "Salt yazılır: keystore'da saklanır, bir daha asla gösterilmez",
    certPem: 'Sertifika (PEM)',
    certPemHint: 'Anahtarla eşleşen genel sertifika',
    certPemCaHint: 'Anahtarla eşleşen CA sertifikası (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Veren',
    parentCa: 'Veren CA',
    parentCaImported: 'İçe aktarıldı — TVirt dışında verildi',
    serial: 'Seri numarası',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'Geçerlilik başlangıcı',
    validUntil: 'Geçerlilik sonu',
    expiry: 'Sona erme',
    expired: 'Süresi doldu',
    expiresInDays: '{days} gün içinde doluyor',
    revoked: 'Geçersiz kılındı',
    revokedAtLabel: 'Geçersiz kılınma tarihi',
    revokeTitle: 'Sertifikayı geçersiz kıl',
    revokeAction: 'Geçersiz kıl',
    revokeWarning: "Geçersiz kılma kesindir: seri numarası veren CA'nın CRL'sine girer ve geçersiz kılınmış sertifikaları reddeden her tüketici (başta OpenVPN) bunu geri çevirir. Un-revoke diye bir şey yoktur.",
    exportPem: "PEM'i dışa aktar",
    exportChain: "Zincir bundle'ını dışa aktar",
    exportCrl: "CRL'yi dışa aktar",
    materialImmutableHint: 'X.509 malzemesi değiştirilemez — yeniden verin ya da yeniden içe aktarın',
    caInUseError: "'{name}' hâlâ canlı verilmiş sertifikalara sahip (ya da bir depolama ona referans veriyor) — önce onları geçersiz kılın ya da silin."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: "Yerleştirme, kullanılabilirlik ve benzeşim — kümelenmiş VM'lerin nerede çalıştığı ve açık olmaları gerekip gerekmediği",
    loadError: "Proximity paneli küme store'unu gerektirir — filo durumuna şu anda erişilemiyor",
    config: {
      title: 'Yapılandırma',
      subtitle: 'Küme genelinde yerleştirme politikası',
      save: 'Kaydet',
      saveError: 'Yapılandırma reddedildi',
      strategy: 'Seçim stratejisi',
      strategy_leastUsedResources: 'En az kullanılan kaynaklar',
      strategy_leastVms: 'En az VM',
      strategy_random: 'Rastgele',
      strategyLeastUsedResourcesHint: "Geçerli adaylar arasında, en çok kullanılabilir RAM'i kalan düğüm (gözlemlenen toplam − host rezervi − açık VM'ler), beraberlik bozucu olarak vCPU taahhüdü. Aynı verilerde deterministik.",
      strategyLeastVmsHint: 'Geçerli adaylar arasında, en az açık VM çalıştıran düğüm; beraberlikler düğüm adına göre çözülür. Aynı verilerde deterministik.',
      strategyRandomHint: 'Geçerli adaylar arasında düzgün dağılımlı rastgele.',
      liveness: 'Düğüm canlılık eşiği (saniye)',
      livenessHint: "Eşiğin ötesinde sessiz kalan bir üye erişilemezdir: yerleştirmeden dışlanır ve — bakımda değilse — HA decider tarafından ölü sayılır; decider onu yalıtır (fencing) ve HA VM'lerini başka yerde yeniden başlatır.",
      decider: 'HA decider',
      deciderNone: 'henüz seçilmedi'
    },
    nodesTitle: 'Düğümler',
    nodesSubtitle: 'Canlılık ve ampirik kapasite — kullanılabilir RAM = toplam − taban − taahhüt edilen',
    nodeCol: 'Düğüm',
    stateCol: 'Durum',
    ramCol: 'RAM (toplam − taban − taahhüt edilen)',
    usableCol: 'Kullanılabilir',
    vmsCol: 'Yük',
    neverSeen: 'hiç görülmedi',
    freshChip: 'erişilebilir',
    staleChip: 'erişilemez',
    attestedChip: 'kapalı beyan edildi',
    ramFormula: 'toplam − taban − taahhüt edilen',
    haTitle: 'Yüksek kullanılabilirlik',
    haSubtitle: 'HA bayraklı bir VM "her zaman açık" demektir: TVirt, istenmemiş her duruştan sonra onu yeniden başlatır — backoff ile aynı düğümde, düğümü öldüğünde başka bir düğümde (yalnızca paylaşılan depolamayla).',
    haNone: 'Henüz hiçbir VM HA bayrağı taşımıyor — burada ya da VM ayrıntısında etkinleştirin.',
    haVmCol: 'Sanal makine',
    haStateCol: 'Durum',
    haRestartsCol: 'HA yeniden başlatmaları',
    haLastEventCol: 'Son olay',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'HA değişikliği reddedildi',
    rules: {
      title: 'Benzeşim kuralları',
      createTitle: 'Yeni yakınlık kuralı',
      editTitle: 'Kuralı düzenle',
      nameHint: 'Küçük harf, rakam ve tire (DNS etiketi)',
      vms: 'Sanal makineler',
      vmsHint: 'En az iki VM — kural, birbirlerine göre nerede çalışacaklarını bağlar',
      type: 'Tür',
      affinity: 'Benzeşim (birlikte)',
      antiAffinity: 'Anti-benzeşim (ayrı)',
      typeAffinityHint: "VM'ler AYNI düğümde çalışmalı.",
      typeAntiAffinityHint: "VM'ler FARKLI düğümlerde çalışmalı — klasik HA çifti.",
      mode: 'Mod',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'İhlaller işlemi (başlatma, geçiş, yük devretme) açıklayıcı bir hatayla reddeder.',
      modeSoftHint: 'Tercih, asla engelleyici değil: ihlaldeki bir yerleştirme görünür bir uyarıyla devam eder.',
      satisfied: 'Yerleştirme',
      satisfiedYes: 'karşılanıyor',
      satisfiedNo: 'ihlal edildi',

      // Dialog standard (round #156).
      violations: 'İhlaller',
      noViolations: 'Yok'
    },
    events: {
      title: 'HA olayları',
      subtitle: 'Kullanılabilirlik günlüğü — yeniden başlatmalar, fencing, yük devretmeler ve dürüst atlamalar',
      none: 'Henüz bir şey yok.',
      when: 'Ne zaman',
      kind: 'Olay',
      target: 'Nesne',
      detail: 'Ayrıntı',
      kindRestarted: 'HA yeniden başlatma',
      kindGaveUp: 'vazgeçildi (crash loop)',
      kindNodeAttested: 'düğüm yalıtıldı (fencing)',
      kindFailedOver: 'yük devretme',
      kindNoCandidate: 'aday yok',
      kindStorageLocalSkip: 'atlandı (yerel depolama)',
      kindZombieFenced: 'zombi sonlandırıldı'
    }
  }
}
